import { isEqual } from 'lodash-es';
import { useEffect, useState } from 'react';

export const OrderLevelSelect = (props) => {
  const {
    handleOrderSelectOption,
    OrderLevelSelectDetails,
    orderLevelCharges,
  } = props;
  const [checkboxItems, setCheckboxItems] = useState([]);

  useEffect(() => {
    const getCheckboxItems = () => {
      let checkBoxOptions = OrderLevelSelectDetails?.options;
      if (!checkBoxOptions) return;
      let checkboxItemList = [];
      for (let i = 0; i < checkBoxOptions.length; i++) {
        let optionForPayload = {
          [`${checkBoxOptions[i].input.key}`]: checkBoxOptions[i].input.value,
        };
        let isPreSelected = false;
        for (let i = 0; i < orderLevelCharges.length; i++) {
          isPreSelected = isEqual(orderLevelCharges[i], optionForPayload);
          if (isPreSelected) break;
        }

        let item = {
          text: checkBoxOptions[i].text,
          selected: isPreSelected,
          key: checkBoxOptions[i].input.key,
          value: checkBoxOptions[i].input.value,
        };

        checkboxItemList.push(item);
      }
      setCheckboxItems([...checkboxItemList]);
    };

    getCheckboxItems();
  }, [OrderLevelSelectDetails, orderLevelCharges]);

  const handleOrderLevelSelect = (event, item) => {
    const { value, checked } = event.target;
    let updatedOrderLevelCharges = [];
    if (checked) {
      const orderChargeSelected = { [`${item.key}`]: value };
      updatedOrderLevelCharges = [...orderLevelCharges, orderChargeSelected];
    } else {
      for (let i = 0; i < orderLevelCharges.length; i++) {
        if (isEqual(orderLevelCharges[i], { [`${item.key}`]: value })) {
          updatedOrderLevelCharges = orderLevelCharges;
          updatedOrderLevelCharges.splice(i, 1);
          i = orderLevelCharges.length;
        }
      }
    }
    handleOrderSelectOption(updatedOrderLevelCharges);
  };

  return (
    <div
      className='checkbox'
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        margin: 0,
        marginBottom: '1rem',
      }}
    >
      {checkboxItems &&
        checkboxItems.map((item, index) => (
          <label key={index}>
            <input
              type='checkbox'
              value={item.value}
              onChange={(event) => {
                handleOrderLevelSelect(event, item);
              }}
              defaultChecked={item?.selected}
            />
            <p>
              <span></span>
              {item.text}
            </p>
          </label>
        ))}
    </div>
  );
};
